import axios, { AxiosResponse } from 'axios'
import { get } from './base'

let getAuth0Source = axios.CancelToken.source()
let getOrganizationSource = axios.CancelToken.source()
let getAdminPortalSource = axios.CancelToken.source()
let getKnowledgeBaseSource = axios.CancelToken.source()
let getQboPromotionSource = axios.CancelToken.source()

const configEndPoint = '/api/config'

export function getAuth0Config() {
  getAuth0Source.cancel('Cancel old get services request')
  getAuth0Source = axios.CancelToken.source()

  return axios.get(`${configEndPoint}/auth0`, {
    cancelToken: getAuth0Source.token,
  })
}

export function getFeatureFlagConfig() {
  return get(`${configEndPoint}/feature-flags`)
}

export function getOrganizationConfig() {
  getOrganizationSource.cancel('Cancel old get services request')
  getOrganizationSource = axios.CancelToken.source()

  return get(configEndPoint, {
    cancelToken: getOrganizationSource.token,
  })
}

interface AdminPortalConfigResponse {
  url: string
}

export function getAdminPortalConfig(): Promise<AxiosResponse<AdminPortalConfigResponse>> {
  getAdminPortalSource.cancel('Cancel old get admin portal request')
  getAdminPortalSource = axios.CancelToken.source()

  return get(`${configEndPoint}/admin-portal`, {
    cancelToken: getAdminPortalSource.token,
  })
}

export interface KnowledgeBaseConfig {
  qbo: string
}

export function getKnowledgeBaseConfig(): Promise<AxiosResponse<KnowledgeBaseConfig>> {
  getKnowledgeBaseSource.cancel('Cancel old get knowledge-base config request')
  getKnowledgeBaseSource = axios.CancelToken.source()

  return get(`${configEndPoint}/knowledge-base`, {
    cancelToken: getKnowledgeBaseSource.token,
  })
}

export interface QboPromotionConfigResponse {
  setup_url: string
}

export function getQboPromotionConfig(): Promise<AxiosResponse<QboPromotionConfigResponse>> {
  getQboPromotionSource.cancel('Cancel old get qbo promotion config request')
  getQboPromotionSource = axios.CancelToken.source()

  return get(`${configEndPoint}/qbo-promotion`, {
    cancelToken: getQboPromotionSource.token,
  })
}
